module.exports = __webpack_public_path__ + "056a6beeec655e4ae23e36bf8428ae77.svg";